const initialState = {
  isOpen: false,
  moveToNext: false,
  isToggleActive: false,
  bucketType: ""
}

export default function toggleIncludeAnnotationModalReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case "TOGGLE_INCLUDE_ANNOTATION_MODAL":
      return {
        ...state,
        isOpen: action.payload.isOpen,
        moveToNext: action.payload.moveToNext,
        isToggleActive: action.payload.isToggleActive,
        bucketType: action.payload.bucketType,
      }
    default:
      return state
  }
}
